import {
    config,
} from './utils';

const getAdminForm = async () => {
    const request = await fetch(config.apiUrl + '/api/admin/form', {
        credentials: 'include',
        mode: 'cors',
    });
    const response = await request.json();
    if (request.status !== 200) {
        throw response;
    }
    return response;
};

const getInscritosEvento = async (evento_id) => {
    return fetch(config.apiUrl + '/api/admin/inscritos-evento/' + evento_id, {
        credentials: 'include',
        mode: 'cors',
    }).then(response => response.json());
};

const aprovarInscricao = async (token_inscricao, formData) => {
    const request = await fetch(config.apiUrl + '/api/admin/aprovar-inscricao/' + token_inscricao, {
        method: 'POST',
        body: JSON.stringify(formData),
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        mode: 'cors',
    });
    const response = await request.json();
    if (request.status !== 200) {
        throw response;
    }
    return response;
};

export {
    getAdminForm,
    getInscritosEvento,
    aprovarInscricao,
};